<app-patient-info [heading]="Item"></app-patient-info>



<div class="card" style="margin-bottom: 8px">
    <div class="grid">
        <div class="col-12 pb-0 md:col-6 xl:col-4 ng-star-inserted">
            <div class="p-3  border-1 surface-border flex align-items-center justify-content-between border-round bg-primary">
                <div class="flex align-items-center bt">
                    <i class="text-2xl mr-3 pi pi-credit-card"></i>
                    <span class="text-900 text-lg font-medium">Encounter Number:</span>
                </div>
                <span class="text-600 text-lg font-semibold">{{ Encounterno }}</span>
            </div>
        </div>
        <div class="col-12 pb-0 md:col-6 xl:col-4 ng-star-inserted">
            <div class="p-3 border-1  surface-border flex align-items-center justify-content-between border-round bg-primary">
                <div class="flex align-items-center">
                    <i class="text-2xl mr-3 pi pi-calendar"></i>
                    <span class="text-900 text-lg font-medium">Billing Date</span>
                </div>
                <span class="text-600 text-lg font-semibold">{{ Billingdate }}</span>
            </div>
        </div>
        <div class="col-12 pb-0 md:col-6 xl:col-4 ng-star-inserted">
            <div class="p-3  border-1 surface-border flex align-items-center justify-content-between border-round bg-primary">
                <div class="flex align-items-center">
                    <i class="text-2xl mr-3 pi pi-verified"></i>
                    <span class="text-900 text-lg font-medium">Rendering Provider</span>
                </div>
                <span class="text-600 text-lg font-semibold">
                    {{
          RenderingProvider
                    }}
                </span>
            </div>
        </div>
    </div>
</div>

<div class="pb-3 col-12" style="text-align: left">
    <button pButton
            type="button"
            pTooltipPosition="true"
            icon="pi pi-link"
            style="font-size: 1.2em"
            label="Back"
            class="ui-button-secondary"
            (click)="backtosummary()"></button>
</div>
<p-tabView [(activeIndex)]="activeIndex">

    <p-tabPanel header="Insurance Details">
        <p-table *ngIf="insurance"
                 [responsive]="true"
                 [columns]="Inscols"
                 [value]="insurance"
                 selectionMode="single">


            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngIf="IsViewInsuranceCard"></th>
                    <th *ngFor="let col of columns">
                        {{ col.header }}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td *ngIf="IsViewInsuranceCard">
                        <button pButton
                                type="button"
                                icon="pi pi-credit-card"
                                class="p-button-info"
                                style="font-size: 0.7em"
                                (click)="getdetails(rowData, 'Insu')"></button>
                    </td>
                    <td *ngFor="let col of columns">
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>

    <p-tabPanel header="Encounter Details">
        <p-table *ngIf="encounter"
                 [responsive]="true"
                 [columns]="enccols"
                 [value]="encounter"
                 selectionMode="single">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th></th>
                    <th *ngFor="let col of columns">
                        {{ col.header }}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-credit-card"
                                class="p-button-info"
                                style="font-size: 0.7em"
                                (click)="getdetails(rowData, 'encdetails')"></button>
                    </td>

                    <td *ngFor="let col of columns">
                        <!--<span class="column-title">{{col.header}}</span>-->
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" let-rowData>
                <tr [pSelectableRow]="rowData">
                    <td colspan="3"><span style="float: right">Encounter Total</span></td>
                    <td>{{ calculateGroupTotal('tc') }}</td>
                    <td>{{ calculateGroupTotal('tap') }}</td>
                    <td>{{ calculateGroupTotal('tadam') }}</td>
                    <td>{{ calculateGroupTotal('tb') }}</td>
                    <td>{{ calculateGroupTotal('tcob1') }}</td>
                    <td>{{ calculateGroupTotal('tcob2') }}</td>
                    <td>{{ calculateGroupTotal('tcob3') }}</td>
                    <td>{{ calculateGroupTotal('tpat') }}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>

    <p-tabPanel header="Encounter Note Details">
        <p-table *ngIf="notedetails"
                 [responsive]="true"
                 [columns]="notecols"
                 [value]="notedetails"
                 selectionMode="single">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th></th>
                    <th *ngFor="let col of columns">
                        {{ col.header }}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-credit-card"
                                class="p-button-info"
                                style="font-size: 0.7em"
                                (click)="getdetails(rowData, 'mess')"></button>
                    </td>

                    <td *ngFor="let col of columns">
                        <!--<span class="column-title">{{col.header}}</span>-->
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
</p-tabView>

<p-dialog [(visible)]="displaypopup"
          [draggable]="true"
          [modal]="true"
          positionType="absolute"
          [style]="{ width: '50vw' }"
          [baseZIndex]="10000"
          [maximizable]="true">
    <p-header>
        {{ popupheader }}
    </p-header>
    <div class="grid" *ngIf="insurancecard == true">
        <div class="col-12 p-md6">
            <div class="thumbnail">
                <img class="profile-image" src="{{ rightimage }}" />
            </div>
        </div>

        <div class="col-12 p-md6">
            <div class="thumbnail">
                <img class="profile-image" src="{{ leftimage }}" />
            </div>
        </div>
    </div>
    <div class="" *ngIf="servicepopup == true">
        <table class="col-12">
            <tr>
                <td class="col--4">
                    <label class="control-label" for="lg">Date of Service:</label>
                    {{ dateofservice }}
                </td>
                <td class="col-2"></td>
                <td class="col-5" style="text-align: end">
                    <label class="control-label" for="lg">Procedure Code:</label>
                    {{ proceduralcode }}
                </td>
            </tr>
        </table>

        <p-table *ngIf="transaction"
                 [responsive]="true"
                 [columns]="trancols"
                 [value]="transaction"
                 selectionMode="single">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngIf="IsViewEOBImage">&nbsp;</th>
                    <th *ngFor="let col of columns">
                        {{ col.header }}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td *ngIf="IsViewEOBImage">
                        <button pButton
                                type="button"
                                icon="pi pi-image"
                                class="ui-button-success"
                                style="font-size: 0.7em"
                                (click)="getdetails(rowData, 'TransactionImg')"></button>
                    </td>
                    <td *ngFor="let col of columns">
                        <!--<span class="column-title">{{col.header}}</span>-->
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="" *ngIf="encounterpopup == true">
        <div class="col-12" [innerHTML]="patientnote"></div>
    </div>
    <p-footer style="display: flex; justify-content: center">
        <button pButton
                type="button"
                icon="pi pi-Error"
                (click)="displaypopup = false"
                label="Cancel"
                class="ui-button-secondary"></button>
    </p-footer>
</p-dialog>

<!--Transactions :: Image Details -->
<p-dialog [(visible)]="displaypopupTransactions"
          [draggable]="true"
          [modal]="true"
          positionType="absolute"
          [style]="{ width: '50vw' }"
          [baseZIndex]="10000"
          [maximizable]="true">
    <p-header>
        {{ popupheader }}
    </p-header>
    <div class="grid">
        <div class="col-12 p-md12">
            <div class="thumbnail">
                <img class="profile-image" src="{{ leftimage }}" />
            </div>
        </div>
    </div>

    <p-footer style="display: flex; justify-content: center">
        <button pButton
                type="button"
                icon="pi pi-Error"
                (click)="displaypopupTransactions = false"
                label="Cancel"
                class="ui-button-secondary"></button>
    </p-footer>
</p-dialog>
